import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row w-100" }
const _hoisted_2 = { class: "card-body w-50" }
const _hoisted_3 = { class: "card-body w-50" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "pb-10 pb-lg-12" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder text-dark" }, "Oversight and Monitoring")
], -1)
const _hoisted_5 = { class: "fv-row" }
const _hoisted_6 = { class: "d-flex flex-stack" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "mb-6" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Will this research be utilizing Gannon University student academic records? (E.g., grades, test scores, reflection assignments, etc.).")
], -1)
const _hoisted_8 = { class: "form-check form-switch form-check-custom form-check-solid mb-7" }
const _hoisted_9 = { class: "form-check-label fw-bold text-gray-400" }
const _hoisted_10 = { class: "fv-row mb-10" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Please list all academic records to be used by this research. "),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "popover",
    "data-bs-trigger": "hover",
    "data-bs-html": "true"
  })
], -1)
const _hoisted_12 = { class: "fv-row" }
const _hoisted_13 = { class: "d-flex flex-stack" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "mb-6" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Is this research being reviewed by any other institutional review board?")
], -1)
const _hoisted_15 = { class: "form-check form-switch form-check-custom form-check-solid mb-7" }
const _hoisted_16 = { class: "form-check-label fw-bold text-gray-400" }
const _hoisted_17 = { class: "fv-row mb-10" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Please enter the name of the institution"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "popover",
    "data-bs-trigger": "hover",
    "data-bs-html": "true"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DropDownSection = _resolveComponent("DropDownSection")!
  const _component_Field = _resolveComponent("Field")!
  const _component_editor = _resolveComponent("editor")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Documents = _resolveComponent("Documents")!
  const _component_DocumentsRO = _resolveComponent("DocumentsRO")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_DropDownSection, {
        title: "Review for more information",
        list: _ctx.listDropDownSections
      }, null, 8, ["list"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("label", _hoisted_8, [
            _createVNode(_component_Field, {
              type: "checkbox",
              class: "form-check-input",
              name: "isUtilizeAcademicRecord",
              value: "1",
              modelValue: _ctx.step4.isUtilizeAcademicRecord,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.step4.isUtilizeAcademicRecord) = $event))
            }, null, 8, ["modelValue"]),
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.step4.isUtilizeAcademicRecord == "1" ? "Yes" : "No"), 1)
          ])
        ])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createVNode(_component_editor, {
          for: "allAcademicRecords",
          initialValue: "step4.allAcademicRecords",
          modelValue: _ctx.step4.allAcademicRecords,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.step4.allAcademicRecords) = $event)),
          "api-key": _ctx.currentEditorToken,
          licenseKey: "gpl",
          init: {
          height: 200,
          menubar: false,
          plugins: [
            'advlist autolink lists link image charmap',
            'searchreplace visualblocks code fullscreen',
            'print preview anchor insertdatetime media',
            'paste code help wordcount table',
          ],
          toolbar:
            'undo redo | formatselect | bold italic |         alignleft aligncenter alignright |         bullist numlist outdent indent | help',
        }
        }, null, 8, ["modelValue", "api-key"]),
        _createVNode(_component_Field, {
          type: "hidden",
          name: "allAcademicRecords",
          class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
          placeholder: "How it will be record?",
          modelValue: _ctx.step4.allAcademicRecords,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.step4.allAcademicRecords) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_ErrorMessage, {
          name: "allAcademicRecords",
          class: "fv-plugins-message-container invalid-feedback"
        })
      ], 512), [
        [_vShow, _ctx.step4.isUtilizeAcademicRecord === '1']
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("label", _hoisted_15, [
            _createVNode(_component_Field, {
              type: "checkbox",
              class: "form-check-input",
              name: "isReviewed",
              value: "1",
              modelValue: _ctx.step4.isReviewed,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.step4.isReviewed) = $event))
            }, null, 8, ["modelValue"]),
            _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.step4.isReviewed == "1" ? "Yes" : "No"), 1)
          ])
        ])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createVNode(_component_Field, {
          class: "form-control form-control-solid",
          placeholder: "Name of the institution",
          name: "reviewerName",
          modelValue: _ctx.step4.reviewerName,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.step4.reviewerName) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_ErrorMessage, {
          name: "reviewerName",
          class: "fv-plugins-message-container invalid-feedback"
        })
      ], 512), [
        [_vShow, _ctx.step4.isReviewed === '1']
      ]),
      _withDirectives(_createElementVNode("div", null, [
        _createVNode(_component_Documents, {
          hiddeDocuments: "true",
          title: "Attach IRB approval letter from outside institution.",
          option: "Approval Letter",
          classification: "Research-Study",
          optionTarget: "#kt_modal_upload_file4"
        }),
        _createVNode(_component_DocumentsRO, {
          title: "Approval Letter",
          option: "Approval Letter",
          hiddeDocuments: "false",
          classification: "Research-Study",
          optionTarget: "#kt_modal_upload_file4"
        })
      ], 512), [
        [_vShow, _ctx.step4.isReviewed === '1']
      ])
    ])
  ]))
}